import { notification } from "antd";
import API from "./Axios";
import {produce} from "immer";

export const resizeTextArea = (e) => {
    for (let i = 0; i < e.target.value.length; i++) {
      e.target.setAttribute(
        "style",
        "height:" + e.target.scrollHeight + "px;overflow-y:hidden;"
      );
    }
  };

 export  function esObjectId(val) {
  return /^[0-9a-fA-F]{24}$/.test(val);
}

export const notify = (type, title, message) => {
  notification[type]({
    message: title,
    description: message,
  });
};

function padZero(str, len) {
  len = len || 2;
  var zeros = new Array(len).join("0");
  return (zeros + str).slice(-len);
}

export const invertColor = (hex, bw) => {
  try {
    if (hex.indexOf("#") === 0) {
      hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
      throw new Error("Invalid HEX color.");
    }
    var r = parseInt(hex.slice(0, 2), 16),
      g = parseInt(hex.slice(2, 4), 16),
      b = parseInt(hex.slice(4, 6), 16);
    if (bw) {
      // https://stackoverflow.com/a/3943023/112731
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? "#000000" : "#FFFFFF";
    }
    // invert color components
    r = (255 - r).toString(16);
    g = (255 - g).toString(16);
    b = (255 - b).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
  } catch (error) {
    return "#0000";
  }
};

export const loadResource = (self, resource, state) => {
  return new Promise(async (resolve, reject) => {
    try {
      const items = await API.get(resource);
      self.setState((prev) => ({ ...prev, [state]: items.data }));
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const saveResource = (self, doc) => {
  self.setState(
    produce((draft) => {
      const index = draft.docs.findIndex((d) => d._id == doc._id);
      if (index > -1) {
        draft.docs[index] = doc;
      } else {
        draft.docs.unshift(doc);
      }
    })
  );
};

export const fileToBase64 = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      resolve(reader.result);
    };
  });
};

/**
 * Convierte una imagen desde una URL a formato Base64.
 * @param {string} url - La ruta o URL de la imagen.
 * @returns {Promise<string>} - Una promesa que resuelve con el string en Base64.
 */
export async function urlToBase64(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`No se pudo cargar la imagen: ${response.statusText}`);
    }
    const blob = await response.blob();
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error al convertir la URL a Base64:', error);
    throw error;
  }
}

export const getUser = () => {
  const token = localStorage.getItem("token");
  if (!token || typeof token !== "string" || token.trim() === "") {
    return null;
  }

  const parts = token.split(".");
  if (!parts || parts.length !== 3 || !parts[1]) {
    return null;
  }

  const base64Url = parts[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  try {
    const jsonPayload = decodeURIComponent(
      atob(base64)
        ?.split("")
        ?.map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        ?.join("")
    );
    return JSON.parse(jsonPayload);
  } catch (err) {
    console.error("getUser: invalid token payload", err);
    return null;
  }
};

export const getNameThumb=(filename)=>{
  if (typeof filename !== 'string') {
    return ""
  }
  if(filename==""){
    return ""
  }
  const ext=filename.split('.').pop();
  return filename.replace('.'+ext,'_thumb.'+ext)
}

export const getExtensionFile=(filename)=>{
  return filename.split('.').pop();
}

export const randomNum = () => Math.floor(Math.random() * (235 - 52 + 1) + 52);
export const randomRGB = () =>
  `rgb(${randomNum()}, ${randomNum()}, ${randomNum()})`;

export const getHttpError=(error)=>{
  return error?.response?.data?.detail || error?.response?.data?.message || error?.response?.data?.errors?.map(e => e.detail + '\n')?.join("\n") || error.toString()
}


export function retrieveErrors(errorObj) {
 
 const error = errorObj;
  const errorMessages = [];

  // 1. Si es string, lo devolvemos directamente como array
  if (typeof error === 'string') {
    return [error];
  }

  // Objeto temporal para manejar la recursión si el error principal está en 'data'
  let currentError = error;

  // 2. Revisar si el error principal (message/errors) está anidado en 'data' 
  //    (Común en respuestas de Axios/Fetch que contienen { data: { message: '...' } })
  if (currentError?.response?.data && typeof currentError.response.data === 'object') {
    currentError = currentError.response.data;
  } else if (currentError?.data && typeof currentError.data === 'object') {
    currentError = currentError.data;
  }
  
  // 3. Intentar extraer el mensaje principal (e.g., de Express o de la propiedad 'data' extraída)
  if (currentError?.message && typeof currentError.message === 'string') {
    // Evitamos duplicar el mensaje si es un error de validación donde el 
    // mensaje principal ya contiene la referencia a los errores anidados.
    const isMongooseValidationError = currentError.name === 'ValidationError';
    
    // Solo lo incluimos si el mensaje no es el genérico de validación de Mongoose
    // o si no hay errores anidados.
    if (!isMongooseValidationError || !currentError.errors) {
        errorMessages.push(currentError.message);
    }
  }

  // 4. Procesar errores de validación anidados (e.g., Mongoose ValidationErrors)
  const erroresAnidados = currentError?.errors;
  if (erroresAnidados && typeof erroresAnidados === 'object') {
    // Mapeamos los mensajes de los errores de validación de campo
    const fieldErrors = Object.values(erroresAnidados).map(err => err.message || `Error en campo: ${err.path}`);
    errorMessages.push(...fieldErrors);
  }
  
  // 5. Fallback genérico si no se encontró ningún mensaje
  if (errorMessages.length === 0) {
    return ['Ocurrió un error inesperado.'];
  }

  // Devolvemos el array de mensajes de error
  return errorMessages;
}


// T2/100A221: nunca rompe la pantalla. Usada directo como render de una tabla antd, recibe (valor, fila,
// índice) y la fila llegaba como "moneda" → RangeError "Invalid currency code : [object Object]". Si la
// moneda o el idioma no son texto válido se usan COP / es-CO; cualquier fallo se registra y se devuelve
// el número sin formato. Antes: new Intl.NumberFormat(locales, { currency: moneda, ... }) sin validar.
export function formatoMoneda(valor, moneda = "COP", locales = "es-CO") {
  if (typeof valor !== "number" || !Number.isFinite(valor)) return "";
  const currency = typeof moneda === "string" && /^[A-Z]{3}$/i.test(moneda) ? moneda.toUpperCase() : "COP";
  const locale = typeof locales === "string" && locales ? locales : "es-CO";
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency, minimumFractionDigits: 0 }).format(valor);
  } catch (error) {
    console.error("[UTIL › formatoMoneda] No se pudo formatear el valor:", error);
    return String(valor);
  }
}

export function hexToRgbWithOpacity(hex, opacidad) {
  if (!/^#([0-9A-Fa-f]{6})$/.test(hex)) {
    throw new Error("El color debe estar en formato #RRGGBB");
  }
  if (opacidad < 0 || opacidad > 1) {
    throw new Error("La opacidad debe estar entre 0 y 1");
  }

  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacidad})`;
}

export function playSound(sound){
  const audio = new Audio("sounds/"+sound)
  audio.play()
}

export function chunkArray(array, size) {
    if (!Array.isArray(array) || size <= 0) {
        return [];
    }

    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
    }
    
    return chunks;
}